import React from 'react'
import PropTypes from 'prop-types'
import { A as Anchor } from 'components/common/Link/Link'

const ModalBoxLink = ({
  name,
  link: {
    path
  } = {},
  altTag,
  onClick
}) =>
  <Anchor href={ path } altTag={ altTag || name } onClick={ onClick }>{ name }</Anchor>

ModalBoxLink.propTypes = {
  altTag: PropTypes.string,
  link: PropTypes.shape({
    path: PropTypes.any
  }),
  name: PropTypes.string,
  onClick: PropTypes.func
}

ModalBoxLink.type = 'ModalBoxLink'

export default ModalBoxLink
